import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { GestorEntradaDetailContent } from '@/components/Gestores/GestorEntradaDetailContent'
import { Button } from '@/components/ui/Button'
import { useGestorEntradaDetailPage } from '@/hooks/useGestorEntradaDetailPage'

export default function GestorEntradaDetailPage() {
  const { detail, loading, error, goBack, handleUpdated } = useGestorEntradaDetailPage()

  return (
    <DashboardLayout
      title={detail?.empresa.nome ?? 'Entrada de cliente'}
      actions={
        <Button variant='secondary' size='sm' type='button' onClick={goBack}>
          <ArrowLeft size={14} />
          Voltar às entradas
        </Button>
      }
    >
      {error && (
        <div className='mb-4 rounded-lg border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-danger'>
          {error}
        </div>
      )}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : detail ? (
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
          <GestorEntradaDetailContent entrada={detail} onUpdated={handleUpdated} />
        </motion.div>
      ) : null}
    </DashboardLayout>
  )
}
